package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.icons.fa.FaIcon
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.BigBadgeStyle
import pl.michal_cyran.brand_hub.CardStyle

@Composable
fun BigBadge(
    text: String,
    icon: String
) {
    Row(
        BigBadgeStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.cssRem)
    ) {
        FaIcon(
            icon,
            modifier = Modifier,
            size = IconSize.LG
        )

        H5 {
            Text(
                text
            )
        }
    }
}